@if (!!event) {
  <div class="page-attributes">
    @if (event.createdByName) {
      <div class="attribute image-section">
        @for (subscriptionRole of subscriptionRoles; track $index) {
          <img class="sub-image" [src]="`assets/images/sub_${subscriptionRole.toLowerCase()}.png`" [alt]="subscriptionRole + ' image'"/>
        }
        <img class="age-image" [src]="`assets/images/${streapper?.isUnderAge ? '18-' : '18+'}.png`" alt="user-age-image" />
        <a [routerLink]="generateLink()" [queryParams]="{ id: event.createdBy }" [title]="'page.detail.navigate_to_profile' | translate">
          <img class="profile-image" alt="Profielafbeelding" [src]="getEventProfilePicture()"
            onerror="this.onerror=null;this.src='/assets/images/user.png';" />
        </a>
        <div class="name">
          <a [routerLink]="generateLink()" [queryParams]="{ id: event.createdBy }" [title]="'page.detail.navigate_to_profile' | translate">
            <span class="username">{{event.createdByName}}</span>
          </a>
        </div>
      </div>
      }
      <div class="attributes">
        @if (event.locationCity) {
          <div class="attribute" [title]="event.locationCity">
            <span class="location">{{event.locationCity}}</span>
          </div>
        }
        <span>•</span>
        @if (event.category) {
          <div class="attribute" [title]="event.created | dateToDescriptionV2">
            <span class="date">{{ event.created | dateToDescriptionV2}}</span>
          </div>
        }
      </div>
      @if (event.tags) {
        <div class="attribute" [title]="event.tags">
          <span class="label">{{'page.detail.tags' | translate}}</span>
          <span class="tags">{{event.tags}}</span>
        </div>
      }
    </div>
  }